import { api } from '../lib/api';
import type { AssetLoan, AssetLoanStatus } from '../types/api';

export interface CreateLoanRequestInput {
  assetId: string;
  dueDate: string;
  notes?: string;
}

export async function createLoanRequest(input: CreateLoanRequestInput): Promise<AssetLoan> {
  const { data } = await api.post<AssetLoan>('/loans', input);
  return data;
}

export interface ListLoansQuery {
  siteId?: string;
  status?: AssetLoanStatus;
}

export async function listLoans(query: ListLoansQuery = {}): Promise<AssetLoan[]> {
  const params = new URLSearchParams();
  if (query.siteId) params.set('siteId', query.siteId);
  if (query.status) params.set('status', query.status);
  const { data } = await api.get<AssetLoan[]>(`/loans?${params.toString()}`);
  return data;
}

export async function getLoanQueue(): Promise<AssetLoan[]> {
  const { data } = await api.get<AssetLoan[]>('/loans/queue');
  return data;
}

export async function getLoan(id: string): Promise<AssetLoan> {
  const { data } = await api.get<AssetLoan>(`/loans/${id}`);
  return data;
}

export async function approveLoan(id: string): Promise<AssetLoan> {
  const { data } = await api.patch<AssetLoan>(`/loans/${id}/approve`, {});
  return data;
}

export async function rejectLoan(id: string, reason?: string): Promise<AssetLoan> {
  const { data } = await api.patch<AssetLoan>(`/loans/${id}/reject`, { reason });
  return data;
}

export async function cancelLoan(id: string): Promise<AssetLoan> {
  const { data } = await api.patch<AssetLoan>(`/loans/${id}/cancel`, {});
  return data;
}

export async function checkoutLoan(id: string, notes?: string): Promise<AssetLoan> {
  const { data } = await api.patch<AssetLoan>(`/loans/${id}/checkout`, { notes });
  return data;
}

export async function checkinLoan(id: string, notes?: string): Promise<AssetLoan> {
  const { data } = await api.patch<AssetLoan>(`/loans/${id}/checkin`, { notes });
  return data;
}
